export default "__VITE_ASSET__BMuTt2T3__"